<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'SETTINGS.SETTINGS' | transloco">
    <sbnb-settings-subnav></sbnb-settings-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs>
        <h2 fxLayout fxLayoutAlign="space-apart center">
          <span fxFlex>Notifications</span>
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
        </h2>
      </sbnb-page-header>
      <h2 fxLayout fxLayoutAlign="space-apart center">
        <span fxFlex>Notifications</span>
        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </h2>
    </app-feature-flag-tabs>

    <!-- Loading state-->
    <mat-spinner *ngIf="loading" [diameter]="32"></mat-spinner>

    <ng-container *ngIf="fieldsMeta && data && !loading">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
        <mat-slide-toggle [(ngModel)]="data.message_sent_emails">
          <strong>{{ fieldsMeta.message_sent_emails.title }}</strong>
        </mat-slide-toggle>
      </div>
      <span class="card__collapsed-helper-text">{{ fieldsMeta.message_sent_emails.description }}</span>

      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
        <mat-slide-toggle [(ngModel)]="data.checkpoint_emails">
          <strong>{{ fieldsMeta.checkpoint_emails.title }}</strong>
        </mat-slide-toggle>
      </div>
      <span class="card__collapsed-helper-text">{{ fieldsMeta.checkpoint_emails.description }}</span>

      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px">
        <mat-slide-toggle [(ngModel)]="data.daily_digest">
          <strong>{{ fieldsMeta.daily_digest.title }}</strong>
        </mat-slide-toggle>
      </div>
      <span class="card__collapsed-helper-text">{{ fieldsMeta.daily_digest.description }}</span>

      <sbnb-button [loading]="saving" size="mini" label="Save changes" (clicked)="save()"></sbnb-button>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Settings'">
  <sbnb-settings-subnav></sbnb-settings-subnav>
</sbnb-mobile-sidebar>
